import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const hideOn = ['/login', '/manager-register', '/truck-register'];
  if (hideOn.includes(path)) return null;

  return (
    <nav className="bottom-nav">
      {/* 홈 */}
      <button
        className={`nav-item ${path === '/' ? 'active' : ''}`}
        onClick={() => navigate('/')}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill={path === '/' ? '#FF6B35' : 'none'}
          stroke={path === '/' ? '#FF6B35' : '#9CA3AF'} strokeWidth="2" strokeLinecap="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9,22 9,12 15,12 15,22"/>
        </svg>
        <span>홈</span>
      </button>

      {/* 지도 */}
      <button
        className={`nav-item ${path === '/truck-match' ? 'active' : ''}`}
        onClick={() => navigate('/truck-match')}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke={path === '/truck-match' ? '#FF6B35' : '#9CA3AF'} strokeWidth="2" strokeLinecap="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <span>공차찾기</span>
      </button>

      {/* 서비스 요청 (중앙 강조) */}
      <button className="nav-center-btn" onClick={() => navigate('/service-select')}>
        <div className="nav-center-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
            stroke="white" strokeWidth="2.5" strokeLinecap="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </div>
        <span>서비스 요청</span>
      </button>

      {/* 배송 추적 */}
      <button
        className={`nav-item ${path === '/tracking' ? 'active' : ''}`}
        onClick={() => navigate('/tracking')}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke={path === '/tracking' ? '#FF6B35' : '#9CA3AF'} strokeWidth="2" strokeLinecap="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <polygon points="16,8 20,8 23,11 23,16 16,16 16,8"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        <span>배송추적</span>
      </button>

      {/* 마이페이지 */}
      <button
        className={`nav-item ${path === '/profile' ? 'active' : ''}`}
        onClick={() => navigate('/profile')}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke={path === '/profile' ? '#FF6B35' : '#9CA3AF'} strokeWidth="2" strokeLinecap="round">
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        <span>마이페이지</span>
      </button>
    </nav>
  );
};

export default BottomNav;
